import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { FormDataConsumer } from 'react-admin';
import BooleanRadioGroupInput from '../../../customFields/BooleanRadioGroupInput';
import TransactionTypeConfigurationInput from '../../../customFields/TransactionTypeConfigurationInput';

const TransactionTypeConfiguration = () => (
  <Card variant="outlined">
    <CardHeader title="Transaction types configuration" subheader="Configure which transaction types this rule should include for detecting patterns. If no filter is applied then all transactions are included by default" />
    <Divider />
    <CardContent>
      <Stack>
        <Typography variant="label">
          Should the rule filter transactions on transaction types?
        </Typography>
        <BooleanRadioGroupInput
          source="ruleParameters.shouldFilterOnTypes"
          label={false}
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData }) => (formData.ruleParameters.shouldFilterOnTypes && (
            <>
              <Typography variant="label" marginBottom={2}>
                Include transactions with a transaction type that:
              </Typography>
              <TransactionTypeConfigurationInput source="ruleParameters.transactionTypeConfiguration" />
            </>
          ))}
        </FormDataConsumer>
      </Stack>
    </CardContent>
  </Card>
);

export default TransactionTypeConfiguration;
